<template>
  <div class="play-list ova h100" @scroll="listScroll">
    <div class="list-item" :key="ind" v-for="ind in total" :ref="'item-' + (ind - 1)">
      <slot :index="ind - 1" :row="innerArr[ind - 1]"></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: "PlayList",
    props: {
      curr: {
        type: Number,
        default: 1
      },
      limits: {
        type: Number,
        default: 30
      },
      total: {
        type: Number,
        default: 0
      },
      getData: Function,
    },
    computed: {
      page() {
        return Math.ceil(this.total / this.limits) || 0;
      },
    },
    watch: {
      total() {
        this.makeData();
      },
      limits() {
        this.makeData();
      },
      curr(v) {
        this.addData(v, 1);
      },
      innerArr() {
        this.initTop();
      },
    },
    data() {
      return {
        currScroll: 0,
        innerArr: [],
        topList: {},
        padding: 200,
        timer: null,
        loading: false,
      };
    },
    methods: {
      initTop() {
        this.$nextTick(() => {
          let all = this.page;
          let topList = {};
          for (; all > 0;) {
            let start = --all * this.limits;
            topList[all + 1] = this.$refs['item-' + start][0].offsetTop;
          }
          this.topList = topList;
        });
      },
      scrollTo(top, step = 100000) {
        if (isNaN(top)) return;
        let c = this.currScroll;
        // let step = 10000;
        let sleep = 30;
        this.$nextTick(async () => {
          await this.Tools.sleep(sleep);
          if (c > top && c - step > top) {
            c -= step;
          } else if (c < top && c + step < top) {
            c += step;
          } else {
            c = top;
          }
          this.currScroll = c;
          c !== top && this.scrollTo(top,step);
          this.$el.scrollTop = c;
        });
      },
      async listScroll(e) {
        if (this.loading) {
          return;
        }
        this.loading = true;
        let top = this.$el.scrollTop;
        let next = 1;
        let min = '0';
        Object.values(this.topList).forEach((num, i) => {
          let abs = Math.abs(num - top);
          if (min === '0' || abs < min) {
            min = abs;
            next = i + 1;
          }
        });
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.loading = false;
          this.$emit('inner-curr-change', next);
        }, 500);
        await this.addData(next);
        // 加载前一页
        (next > 1) && this.addData(next - 1);
        // 最后一页加载不到
        (next + 1 > this.page) || this.addData(next + 1);
        this.currScroll = top;
      },
      async addData(curr = this.curr, to) {
        try {
          let {page, limits, topList, innerArr} = this;
          let currList = innerArr.slice((curr - 1) * limits, curr * limits);
          if (curr > page) {
            throw {type: 'curr-error', curr, page};
          }
          if (typeof this.getData === 'function' && !Object.keys(currList[0]).length) {
            innerArr.splice((curr - 1) * limits, limits, ...await this.getData(curr, limits));
          }
          if (currList.length < limits && curr < page) {
            throw {type: 'data-length-error', list: currList, curr, page};
          }
          to && this.scrollTo(topList[curr]);
        } catch (e) {
          this.$emit('get-data-error', e);
        }
      },
      async makeData() {
        let {total} = this;
        this.innerArr = '-'.repeat(total).split('').map(() => ({}));
        await this.addData();
      },
    },
    created() {
      this.makeData();
    },
  }
</script>

<style scoped>
.play-list{
  scrollbar-width: none;
}

</style>